module.exports = __webpack_public_path__ + "static/media/route.20dd1aa9.svg";